export const VALIDATE_CLIENT_ERROR_MESSAGE =
  "The specified redirect URL is invalid";
